<template>
  <div>
    <the-nav-bar :title="$t('createPost.customizePrice')" />
    <div class="body-wrapper">
      <div class="col dynamic-panel">
        <div class="panel-header">
          <p class="strong text">
            {{ $t('customize.dynamicPriceText[0]') }}
          </p>
          <p class="text">{{ $t('customize.dynamicPriceText[1]') }}</p>
        </div>
        <div class="panel-body field">
          <div
            class="field-item row-justify-center"
            @click="showPopup('reference')"
          >
            <div class="field-item-title">
              {{ $t('customize.dynamicReference') }}
            </div>
            <div
              class="field-item-content"
              :class="{ inactive: reference === '' }"
            >
              {{
                (referenceList[reference] && referenceList[reference].text) ||
                  $t('createPost.default')
              }}
            </div>
            <div class="field-item-right">
              <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
            </div>
          </div>
          <div
            class="field-item row-justify-center"
            @click="showPopup('above')"
          >
            <div class="field-item-title">
              {{ $t('customize.dynamicAboveOrBelow') }}
            </div>
            <div
              class="field-item-content"
              :class="{ inactive: isAbove === '' }"
            >
              {{
                (aboveList[isAbove] && aboveList[isAbove].text) ||
                  $t('createPost.default')
              }}
            </div>
            <div class="field-item-right">
              <md-icon name="arrow-right" size="sm" color="#84969C"></md-icon>
            </div>
          </div>
          <div
            class="field-item row-justify-center"
            v-if="exinoneReferenceId != reference"
          >
            <div class="field-item-title">
              {{ $t('customize.percentage') }}
            </div>
            <div class="field-item-content">
              <md-input-item
                v-model="percent"
                v-input-mode="'decimal'"
                type="number"
                class="input-item"
                align="right"
                @blur="onPercentBlur"
                @change="onPercentChange"
              >
                <div class="error" slot="left">{{ $t() }}</div>
                <div class="unit" slot="right">%</div>
              </md-input-item>
            </div>
          </div>
          <div class="field-item row-justify-center" v-else>
            <div class="field-item-title">
              {{ $t('customize.difference') }}
            </div>
            <div class="field-item-content">
              <md-input-item
                v-model="difference"
                v-input-mode="'decimal'"
                type="number"
                class="input-item"
                align="right"
                @change="onDifferenceChange"
              >
                <div class="unit" slot="right">CNY</div>
              </md-input-item>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <p class="text">
            {{
              $t('customize.referenceText', {
                symbol: symbol,
                unit: unit,
                buyPrice: buyPrice,
                sellPrice: sellPrice,
              })
            }}
          </p>
          <md-button
            :type="isDynamicBtnDisabled ? 'disabled' : 'primary'"
            class="btn"
            @click="onDynamicBtnClick"
          >
            <span>{{ $t('common.confirm') }}</span>
          </md-button>
        </div>
      </div>
    </div>
    <md-popup v-model="isShowPopup" position="bottom" class="popup">
      <md-popup-title-bar
        only-close
        large-radius
        class="title-bar"
        :title="popupData.title"
        @confirm="hidePopup"
        @cancel="hidePopup"
      />
      <md-scroll-view :scrolling-x="false" auto-reflow class="popup-body">
        <div
          class="popup-item row-center"
          v-for="(item, index) in popupData.list"
          :key="`popup-item-${popupData.name}-${index}`"
          :class="{ active: index === popupData.value }"
          @click="onChoose(index)"
        >
          <div class="text">{{ item.text }}</div>
        </div>
      </md-scroll-view>
    </md-popup>
  </div>
</template>

<script>
import TheNavBar from '@/components/the-nav-bar';
import {
  Tabs,
  TabPane,
  InputItem,
  Button,
  Icon,
  Popup,
  PopupTitleBar,
  ScrollView,
  Toast,
} from 'mand-mobile';
import { mapState } from 'vuex';
import getCurrentPrice from '@/api/get-current-price';
import toFixed from '@/utils/to-fixed';
export default {
  components: {
    'the-nav-bar': TheNavBar,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Popup.name]: Popup,
    [PopupTitleBar.name]: PopupTitleBar,
    [ScrollView.name]: ScrollView,
  },
  data() {
    return {
      fiatCurrencyId: '', // 法币ID
      cryptoId: '', // 加密货币ID
      preferencePrice: '',
      reference: '', //参考对象
      isAboveQuery: '', // 最小值/最大值查询参数
      isAbove: '', // 高于还是低于
      percent: '', // 百分比
      isEdit: false, // 是否修改
      isSubmitting: false,
      isShowPopup: false,
      popupData: {
        name: '',
        title: '',
        value: '',
        list: [],
      },
      difference: '',
      exinBuyPrice: 0,
      exinSellPrice: 0,
    };
  },
  computed: {
    ...mapState({
      settings: state => state.settings,
      noticeTemp: state => state.noticeTemp,
      noticeStore: state => state.noticeStore,
      legalCurrencyList: state => state.settings.legalCurrencyList,
      cryptoList: state => state.settings.cryptoList,
      exinoneReferenceId: state => state.settings.exinoneReferenceId,
      references: state => state.settings.referenceList,
      advertisementRate(state) {
        return (
          state.userInfo.advertisementRate ||
          state.settings.rate.advertisementRate
        );
      },
    }),
    config() {
      const { cryptoId, fiatCurrencyId, cryptoList, legalCurrencyList } = this;
      const asset = cryptoList.find(item => item.id == cryptoId);
      const currency = legalCurrencyList.find(
        item => item.id == fiatCurrencyId,
      );
      return {
        exinSupported:
          asset && asset.exinSupported && currency && currency.unit == 'CNY',
        decimalDigit: asset && asset.exinDecimalDigit,
      };
    },
    referenceList() {
      return this.references
        .map(item => {
          if (item.id == this.exinoneReferenceId) {
            return Object.assign({}, item, {
              text: this.$t('customize.exinone'),
            });
          } else {
            return Object.assign({}, item);
          }
        })
        .filter(item => {
          if (item.id == this.exinoneReferenceId) {
            return this.config.exinSupported;
          }
          return true;
        });
    },
    isDynamicBtnDisabled() {
      return (
        (this.reference != this.exinoneReferenceId &&
          (this.percent === '' ||
            this.percent >= 100 ||
            this.percent <= 0 ||
            isNaN(this.percent))) ||
        (this.reference == this.exinoneReferenceId &&
          (this.difference === '' ||
            isNaN(this.difference) ||
            !+this.difference)) ||
        this.isSubmitting ||
        this.reference === '' ||
        this.isAbove === ''
      );
    },
    aboveList() {
      return [
        {
          value: 0,
          text: this.$t('notice.below'),
        },
        {
          value: 1,
          text: this.$t('notice.above'),
        },
      ];
    },
    unit() {
      const obj = this.legalCurrencyList.find(item => {
        return item.id === this.fiatCurrencyId;
      });
      return (obj && obj.unit) || '';
    },
    symbol() {
      const obj = this.cryptoList.find(item => {
        return item.id === this.cryptoId;
      });
      return (obj && obj.symbol) || '';
    },
    sellPrice() {
      const advertisementRate = +this.advertisementRate;
      if (this.currentTab === 'fixed') {
        const price = +this.fixedPrice;
        return toFixed(price * (1 - advertisementRate / 100), 2);
      } else {
        if (this.isAbove === '' || this.reference === '') {
          return this.preferencePrice;
        }
        if (
          this.referenceList[this.reference] &&
          this.referenceList[this.reference].value === 'exinone'
        ) {
          let output = (1 - advertisementRate / 100) * +this.exinSellPrice;
          if (this.isAbove) {
            return toFixed(
              output + Number(this.difference),
              this.config.decimalDigit,
            );
          } else {
            return toFixed(
              output - Number(this.difference),
              this.config.decimalDigit,
            );
          }
        } else {
          const percent = +this.percent;
          let rate;
          if (this.isAbove) {
            rate = 1 + percent / 100;
          } else {
            rate = 1 - percent / 100;
          }
          return toFixed(
            rate * (1 - advertisementRate / 100) * +this.preferencePrice,
            2,
          );
        }
      }
    },
    buyPrice() {
      const advertisementRate = +this.advertisementRate;
      if (this.currentTab == 'fixed') {
        const price = +this.fixedPrice;
        return toFixed(price * (1 + advertisementRate / 100), 2);
      } else {
        if (this.isAbove === '' || this.reference === '') {
          return this.preferencePrice;
        }
        if (
          this.referenceList[this.reference] &&
          this.referenceList[this.reference].value === 'exinone'
        ) {
          let output = (1 - advertisementRate / 100) * +this.exinBuyPrice;
          if (this.isAbove) {
            return toFixed(
              output + Number(this.difference),
              this.config.decimalDigit,
            );
          } else {
            return toFixed(
              output - Number(this.difference),
              this.config.decimalDigit,
            );
          }
        } else {
          const percent = +this.percent;
          let rate;
          if (this.isAbove) {
            rate = 1 + percent / 100;
          } else {
            rate = 1 - percent / 100;
          }
          return toFixed(
            rate * (1 + advertisementRate / 100) * +this.preferencePrice,
            2,
          );
        }
      }
    },
  },
  mounted() {
    const query = this.$route.query;
    if (
      !query.fiatCurrencyId ||
      !query.cryptoId ||
      !this.settings.isSettingsLoaded
    ) {
      Toast.failed(`${this.$t('error.occur')} ${this.$t('error.para')}`);
      return this.$router.replace('/mine/alert/add');
    }
    this.fiatCurrencyId = query.fiatCurrencyId;
    this.cryptoId = query.cryptoId;
    this.isAboveQuery = query.isAboveQuery;
    this.isEdit = query.isEdit;
    // 上一次保存的数据
    const { reference, minPercentage, maxPercentage, maxGap, minGap } = this
      .isEdit
      ? this.noticeStore
      : this.noticeTemp;
    this.reference = reference || this.referenceList[0].id;
    if (this.reference != this.exinoneReferenceId) {
      if (
        (this.isAboveQuery && maxPercentage) ||
        (!this.isAboveQuery && minPercentage)
      ) {
        this.percent = this.isAboveQuery
          ? Number(maxPercentage)
          : Number(minPercentage);
        this.isAbove = this.percent < 0 ? 0 : 1;
        this.percent = Math.abs(this.percent);
      }
    } else {
      if ((this.isAboveQuery && maxGap) || (!this.isAboveQuery && minGap)) {
        this.difference = this.isAboveQuery ? Number(maxGap) : Number(minGap);
        this.isAbove = this.difference < 0 ? 0 : 1;
        this.difference = Math.abs(this.difference);
      }
    }
    Toast.loading(this.$t('common.loading'));
    this.loadReferencePrice()
      .then(() => {
        Toast.hide();
      })
      .catch(err => {
        Toast.failed(`${this.$t('error.occur')}${err.message}`);
      });
  },
  methods: {
    onDynamicBtnClick() {
      this.isSubmitting = true;
      let percent = this.percent;
      let difference = this.difference;
      const obj = {
        reference: this.reference,
      };
      if (obj.reference != this.exinoneReferenceId) {
        percent = this.isAbove === 0 ? `-${this.percent}` : this.percent;
        this.isAboveQuery
          ? (obj.maxPercentage = percent)
          : (obj.minPercentage = percent);
      } else {
        difference = this.isAbove === 0 ? `-${difference}` : difference;
        this.isAboveQuery
          ? (obj.maxGap = difference)
          : (obj.minGap = difference);
      }
      this.$store.commit(this.isEdit ? 'setNoticeStore' : 'setNoticeTemp', obj);
      this.$nextTick(() => {
        this.isSubmitting = false;
        this.$router.back();
      });
    },
    onPercentBlur() {
      if (this.percent <= 0) {
        Toast.info(this.$t('notice.notZero'));
        this.$nextTick(() => {
          this.percent = '';
        });
      }
    },
    onPercentChange() {
      if (this.percent >= 100) {
        this.percent = 99.99;
      }
      this.$nextTick(() => {
        this.percent = this.fixDecimal(this.percent, 2);
      });
    },
    showPopup(name) {
      if (name == 'reference') {
        this.popupData.title = this.$t('customize.dynamicReference');
        this.popupData.value = this.reference;
      }
      if (name == 'above') {
        this.popupData.title = this.$t('customize.dynamicAboveOrBelow');
        this.popupData.value = this.isAbove;
      }
      this.popupData.name = name;
      this.popupData.list = this[`${name}List`];
      this.$nextTick(() => {
        this.isShowPopup = true;
      });
    },
    hidePopup() {
      this.isShowPopup = false;
    },
    onChoose(index) {
      this.popupData.value = index;
      if (this.popupData.name == 'reference') {
        this.reference = index;
      }
      if (this.popupData.name == 'above') {
        this.isAbove = index;
      }
      this.hidePopup();
    },
    loadReferencePrice() {
      return getCurrentPrice(this.cryptoId, this.fiatCurrencyId).then(data => {
        this.preferencePrice = data.data.price;
        this.exinBuyPrice = data.data.exin_buy_price || 0;
        this.exinSellPrice = data.data.exin_sell_price || 0;
      });
    },
    //截掉小数点后指定位数的值
    fixDecimal(num, decimal) {
      let sumArr = num.toString().split('.');
      if (sumArr[1] !== undefined && sumArr[1].length > decimal) {
        sumArr[1] = sumArr[1].slice(0, decimal);
        if (sumArr[1]) {
          return sumArr.join('.');
        } else {
          return sumArr[0];
        }
      } else {
        return num;
      }
    },
    onDifferenceChange() {
      this.$nextTick(() => {
        if (this.difference === '') {
          return;
        }
        if (this.difference < 0) {
          this.difference = 0;
          return;
        }
        let output = this.fixDecimal(this.difference, this.config.decimalDigit);
        while (output[0] === '0' && output[1] && output[1] !== '.') {
          output = output.slice(1);
        }
        this.difference = output;
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.body-wrapper {
  padding: 6.4vw 0 30vw;

  >>> .md-tab-bar-item {
    flex: 0 0 50vw;
  }
}

.dynamic-panel {
  padding-top: 9.6vw;

  .panel-header {
    margin: 0 4.8vw;

    .text {
      margin-bottom: 4.8vw;
      font-size: 3.2vw;
    }

    .strong {
      font-size: 3.73vw;
    }
  }

  .panel-body {
    .field-item {
      height: 17.07vw;
      padding: 0 4.8vw;
      font-size: 3.73vw;

      &:nth-child(even) {
        background: #f8fBfc;
      }
    }

    .field-item-title {
      flex: 0 0 32vw;
      font-weight: bold;
    }

    .field-item-content {
      flex: 1 0 0;
      text-align: right;
      color: color-primary;

      &.inactive {
        color: #BCC7CB;
      }
    }

    .field-item-right {
      margin-left: 1.07vw;
    }

    .input-item {
      padding: 0 2.13vw;
      border: 0.27vw solid #EAF1F3;
      border-radius: 2.67vw;
      background: #F8FBFC;

      >>> .md-field-item-content:before {
        content: none;
      }

      .unit {
        margin-left: 4.8vw;
        font-size: 3.73vw;
        color: #1b6fdc;
      }
    }
  }

  .panel-footer {
    margin: 0 4.8vw;

    .text {
      margin-top: 4.8vw;
    }

    .btn {
      margin-top: 9.6vw;
    }
  }
}

.popup {
  .title-bar {
    border-bottom: 0.27vw solid #eaf1f3;

    >>> .title-bar-left, >>> .title-bar-right {
      width: 30%;
    }
  }

  .popup-body {
    padding-bottom: 10vw;
    height: auto;
    min-height: 60vw;
    max-height: 80vw;
    overflow-y: auto;
    background: #fff;
  }

  .popup-item {
    height: 12.8vw;
    margin: 0 6.4vw;
    font-size: 4.27vw;

    &.active {
      color: color-primary;
    }
  }
}
</style>
